import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Monaco workers (AMD build) must bootstrap through workerMain.js.
(window as any).MonacoEnvironment = {
  getWorkerUrl: (_moduleId: string, label: string) => {
    const workerLabel = encodeURIComponent(label || 'editorWorkerService');
    const monacoBaseUrl = `${window.location.origin}/assets/monaco/min/`;
    const workerBootstrap = [
      "self.MonacoEnvironment = {",
      `  baseUrl: '${monacoBaseUrl}',`,
      `  workerLabel: '${workerLabel}'`,
      '};',
      `importScripts('${monacoBaseUrl}vs/base/worker/workerMain.js');`
    ].join('\n');

    return `data:text/javascript;charset=utf-8,${encodeURIComponent(workerBootstrap)}`;
  }
};

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
